var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarmUpTshirt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.6359 21.6095C40.3352 18.6864 39.3057 15.8855 37.6417 13.4636C35.9777 11.0416 33.7325 9.07593 31.1118 7.74676L30.7981 7.58472H15.2L14.8863 7.74676C12.2656 9.07593 10.0204 11.0416 8.35643 13.4636C6.69246 15.8855 5.66295 18.6864 5.36224 21.6095L5.28906 23.1097H10.6993V38.4152H22.5443V35.5454H13.5534V20.2504H8.45156C8.91696 18.1778 9.82373 16.2298 11.1101 14.5394C12.3964 12.8489 14.0321 11.4556 15.9057 10.4545H30.0925C31.966 11.4556 33.6017 12.8489 34.888 14.5394C36.1744 16.2298 37.0812 18.1778 37.5466 20.2504H32.4447V35.5454H22.5443V38.3995H35.2988V23.1097H40.7091L40.6359 21.6095Z",
    fill: "#A6A6A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1468 16.4921C19.2368 16.4921 16.0586 13.7844 16.0586 10.4546H18.9127C18.9127 12.2057 20.8102 13.638 23.1468 13.638C25.4834 13.638 27.3756 12.2057 27.3756 10.4546H30.235C30.235 13.7844 27.0515 16.4921 23.1468 16.4921Z",
    fill: "#A6A6A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarmUpTshirt);
export default __webpack_public_path__ + "static/media/warm_up_tshirt.72b25f0a98ec13af67727b29e9598cda.svg";
export { ForwardRef as ReactComponent };